// Valores do campo "frota" no cadastro (back-end: FrotasModel.Frota,
// exposto na API como TremDto.tipoTrem) — o número da frota já É o modelo
// físico do trem (CAF/Charlie = 7500, Alstom/Alfa = 8900), não existe um
// campo de "tipo" separado no cadastro do trem.
//
// Por que o valor semântico ("7500"/"8900") e não o id da linha na tabela
// "frotas": esse id é uma chave primária de auto-incremento e não tem
// garantia de ser o mesmo em bancos diferentes (dev/homolog/produção),
// depende da ordem de inserção de cada um. Já o valor da frota é o dado
// estável que de fato identifica o modelo, então é ele que compõe essa
// constante — usar em vez de comparar strings soltas pelo código.
export const TIPO_TREM = Object.freeze({
    TREM_7500: "7500",
    TREM_8900: "8900"
});

// Fallback usado só quando o trem não tem frota cadastrada (dado legado ou
// ausente). NÃO é "o" modelo padrão do sistema — os dois tipos são
// igualmente válidos, evite lógica que trate esse valor como referência.
export const TIPO_TREM_FALLBACK = TIPO_TREM.TREM_8900;
